import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderLinkComponent } from './header-link/header-link.component';

@Component({
  selector: 'app-customer-space-administration-link',
  standalone: true,
  imports: [CommonModule, HeaderLinkComponent, TranslateModule],
  template: `
    <app-header-link
      [caption]="'cockpit.admin-title' | translate"
      icon="edituser_icon"
      [link]="['/', 'customer-spaces', customerSpaceId, 'admin']"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSpaceAdministrationLinkComponent {
  @Input({ required: true }) customerSpaceId: string;
}
